<div class="error-container">
    <div class="logo"><img src="/assets/images/robot.svg"
            class="logo"
            alt="logo"></div>
    <div class="error-size">401</div>
    <div class="msg-size">Sorry. No Roles Tagged!</div>
    <p>Please contact the Admin to get role Tagged and try again!
        Thank you.</p>
</div>